// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application";

import AddressController from "./address_controller";
application.register("address", AddressController);

import PricingToggleController from "./pricing_toggle_controller";
application.register("pricing-toggle", PricingToggleController);
